import {
  containsGreaterThanOrLessThanSign,
  hasNoValue,
  hasNoValueForProperty,
  hasNoValueOrNoInformation,
  ifStringWithNumberThenGreaterThanZero,
  isCharsLengthGreaterThan,
  isDateInThePast,
  isDependentFieldFloorNumberNotGiven,
  isDependentFieldFreeUntilNotGiven,
  isDependentFieldMoveInDateNotGiven,
  isDependentFieldTotalFloorsNumberNotGiven,
  isFreeUntilBeforeMoveInDate,
  isGarageGreaterThan,
  isInvalidDecimalNumber,
  isInvalidDecimalNumberWithOneDecimalPlace,
  isInvalidEmailAddress,
  isInvalidFlatShareSize,
  isInvalidGender,
  isInvalidIntegerNumber,
  isInvalidIntegerWithSeparator,
  isInvalidNumber,
  isInvalidOptionalYear,
  isInvalidPhoneNumberString,
  isInvalidPostcode,
  isLargerThanAgeOfFlatMatesToField,
  isLargerThanAgeOfRequestedToField,
  isLargerThanMaxRentalTimeField,
  isLargerThanTotalFloors,
  isNumberEqualOrLessThanZero,
  isNumberGreaterThan,
  isNumberLessThan,
  isNumberNotDividableByZeroPointFive,
  isRequiredWhenHasCourtage,
  isSmallerThanAgeOfFlatMatesFromField,
  isSmallerThanAgeOfRequestedFromField,
  isSmallerThanFloorField,
  isSmallerThanMinRentalTimeField,
  validateZuoraForbiddenCharactersForField,
} from './validationFunctions'
import { ValidationRule } from '../../../@types/validation-types'

export const validationRulesRaw = {
  street: [hasNoValueForProperty, containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(100)],
  houseNumber: [hasNoValueForProperty, containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(30)],
  postcode: [containsGreaterThanOrLessThanSign, hasNoValue, isInvalidPostcode, isCharsLengthGreaterThan(5)],
  manualCity: [hasNoValue],
  manualQuarter: [hasNoValue],
  manualRegion: [hasNoValue],
  manualCountry: [hasNoValue],
  internationalStreet: [containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(100)],
  internationalHouseNumber: [containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(30)],
  internationalPostcode: [containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(20)],
  city: [hasNoValue, containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(50)],
  buildingType: [hasNoValueOrNoInformation],
  pricePeriodType: [hasNoValueOrNoInformation],
  mainFloorSpaceRequired: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999),
    isInvalidDecimalNumber,
    hasNoValue,
  ],
  mainFloorSpace: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999),
    isInvalidDecimalNumber,
  ],
  auxiliaryArea: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999999),
    isInvalidDecimalNumber,
  ],
  additionalArea: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999999),
    isInvalidDecimalNumber,
  ],
  livingSpace: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isNumberGreaterThan(99999),
    isInvalidDecimalNumber,
    hasNoValue,
  ],
  livingSpaceInvestment: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999),
    isInvalidDecimalNumber,
  ],
  livingSpaceFlatShareRoom: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999),
    isInvalidDecimalNumber,
  ],
  mainFloorSpaceHangar: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999.99),
    isInvalidDecimalNumber,
    hasNoValue,
  ],
  separableSpace: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isNumberGreaterThan(99999),
    isInvalidDecimalNumber,
  ],
  separableSpaceHangar: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isInvalidDecimalNumber,
    isNumberGreaterThan(99999999.99),
  ],
  totalFloorSpace: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999.99),
    isInvalidDecimalNumber,
    hasNoValue,
  ],
  totalFloorSpaceOptional: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999.99),
    isInvalidDecimalNumber,
  ],
  plotArea: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999.99),
    isInvalidDecimalNumber,
    hasNoValue,
  ],
  plotAreaOptional: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999.99),
    isInvalidDecimalNumber,
  ],
  industrialArea: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999.99),
    isInvalidDecimalNumber,
  ],
  room: [
    containsGreaterThanOrLessThanSign,
    isNumberGreaterThan(999),
    isNumberNotDividableByZeroPointFive,
    isInvalidDecimalNumberWithOneDecimalPlace,
    hasNoValue,
    isNumberEqualOrLessThanZero,
  ],
  roomFlatShareRoom: [
    containsGreaterThanOrLessThanSign,
    isNumberGreaterThan(100),
    isNumberNotDividableByZeroPointFive,
    isInvalidDecimalNumberWithOneDecimalPlace,
    isNumberEqualOrLessThanZero,
  ],
  moveInDateRequired: [hasNoValue],
  moveInDateRequiredAndStrict: [hasNoValue, isDependentFieldFreeUntilNotGiven, isFreeUntilBeforeMoveInDate],
  freeUntilRequiredAndStrict: [hasNoValue, isDependentFieldMoveInDateNotGiven, isFreeUntilBeforeMoveInDate],
  price: [isNumberEqualOrLessThanZero, isNumberGreaterThan(99999999999), hasNoValue],
  pricePerSQM: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  rentalIncomeTarget: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  rentalIncomeActual: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  priceMultiplier: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isNumberGreaterThan(100),
    isInvalidDecimalNumber,
  ],
  additionalCosts: [containsGreaterThanOrLessThanSign, isNumberLessThan(0), isNumberGreaterThan(99999999999)],
  serviceCharge: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  deposit: [containsGreaterThanOrLessThanSign],
  heatingCosts: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  courtageNote: [containsGreaterThanOrLessThanSign],
  baseRent: [
    containsGreaterThanOrLessThanSign,
    hasNoValueForProperty,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999999),
  ],
  courtage: [containsGreaterThanOrLessThanSign, isRequiredWhenHasCourtage, ifStringWithNumberThenGreaterThanZero],
  adTitle: [hasNoValueForProperty, containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(100)],
  adDescription: [containsGreaterThanOrLessThanSign],
  adLocation: [containsGreaterThanOrLessThanSign],
  adOther: [containsGreaterThanOrLessThanSign],
  adFurnishingNote: [containsGreaterThanOrLessThanSign],
  salutation: [],
  name: [containsGreaterThanOrLessThanSign, validateZuoraForbiddenCharactersForField, hasNoValueForProperty],
  phoneNumber: [containsGreaterThanOrLessThanSign, isInvalidPhoneNumberString],
  email: [containsGreaterThanOrLessThanSign, hasNoValueForProperty, isInvalidEmailAddress],
  constructionLastModernization: [containsGreaterThanOrLessThanSign, isInvalidNumber, isInvalidOptionalYear],
  constructionYear: [containsGreaterThanOrLessThanSign, isInvalidNumber, isInvalidOptionalYear],
  legalConstructionYear: [containsGreaterThanOrLessThanSign, isCharsLengthGreaterThan(999)],
  thermalCharacteristic: [
    containsGreaterThanOrLessThanSign,
    isInvalidDecimalNumber,
    isNumberLessThan(0),
    isNumberGreaterThan(1999.99),
  ],
  thermalCharacteristicRequired: [
    containsGreaterThanOrLessThanSign,
    hasNoValue,
    isInvalidDecimalNumber,
    isNumberLessThan(0),
    isNumberGreaterThan(1999.99),
  ],
  parkingSpaceRent: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  noParkingSpaces: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999),
    isInvalidIntegerNumber,
  ],
  floorLoad: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isInvalidDecimalNumber,
    isNumberGreaterThan(99999.99),
  ],
  powerSupply: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999),
    isInvalidIntegerWithSeparator,
  ],
  loadLiftingValue: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isInvalidDecimalNumber,
    isNumberGreaterThan(99999.99),
  ],
  craneValue: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999),
    isInvalidIntegerWithSeparator,
  ],
  widthGarage: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isInvalidDecimalNumber,
    isNumberGreaterThan(99.99),
  ],
  lengthGarage: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isInvalidDecimalNumber,
    isNumberGreaterThan(99.99),
  ],
  heightGarage: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isInvalidDecimalNumber,
    isNumberGreaterThan(99.99),
  ],
  usableGarageArea: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isInvalidDecimalNumber,
    isGarageGreaterThan(99.99),
  ],
  usableArea: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999.99),
    isInvalidDecimalNumber,
    isInvalidDecimalNumber,
    isNumberGreaterThan(99999999.99),
  ],
  noBathrooms: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
  ],
  noBedrooms: [containsGreaterThanOrLessThanSign, isNumberLessThan(0), isNumberGreaterThan(99), isInvalidIntegerNumber],
  floor: [
    containsGreaterThanOrLessThanSign,
    isInvalidNumber,
    isNumberLessThan(-1),
    isNumberGreaterThan(99),
    isLargerThanTotalFloors,
    isDependentFieldTotalFloorsNumberNotGiven,
  ],
  floorRequired: [
    containsGreaterThanOrLessThanSign,
    hasNoValue,
    isInvalidNumber,
    isNumberLessThan(-1),
    isNumberGreaterThan(99),
    isLargerThanTotalFloors,
    isDependentFieldTotalFloorsNumberNotGiven,
  ],
  totalFloorsWithDependingFloorNumber: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
    isSmallerThanFloorField,
    isDependentFieldFloorNumberNotGiven,
  ],
  totalFloorsWithDependingFloorNumberAndRequired: [
    containsGreaterThanOrLessThanSign,
    hasNoValue,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
    isSmallerThanFloorField,
    isDependentFieldFloorNumberNotGiven,
  ],
  totalFloors: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
  ],
  distanceToPT: [containsGreaterThanOrLessThanSign, isInvalidNumber, isNumberLessThan(0)],
  distanceToMRS: [containsGreaterThanOrLessThanSign, isInvalidNumber, isNumberLessThan(0)],
  distanceToFM: [containsGreaterThanOrLessThanSign, isInvalidNumber, isNumberLessThan(0)],
  distanceToAirport: [containsGreaterThanOrLessThanSign, isInvalidNumber, isNumberLessThan(0)],
  minimumTermOfLease: [
    containsGreaterThanOrLessThanSign,
    isNumberEqualOrLessThanZero,
    isNumberGreaterThan(999),
    isInvalidIntegerNumber,
  ],
  requestedGender: [isInvalidGender],
  numberOfRequestedFlatMates: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
  ],
  flatShareSize: [containsGreaterThanOrLessThanSign, hasNoValue, isInvalidIntegerNumber, isInvalidFlatShareSize],
  ageOfRequestedFrom: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
    isLargerThanAgeOfRequestedToField,
  ],
  ageOfRequestedTo: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
    isSmallerThanAgeOfRequestedFromField,
  ],
  numberOfMaleFlatMates: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
  ],
  numberOfFemaleFlatMates: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
  ],
  ageOfFlatMatesFrom: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
    isLargerThanAgeOfFlatMatesToField,
  ],
  ageOfFlatMatesTo: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99),
    isInvalidIntegerNumber,
    isSmallerThanAgeOfFlatMatesFromField,
  ],
  roomSize: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999),
    isInvalidDecimalNumber,
    hasNoValue,
  ],
  rentSubsidy: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  rentalIncome: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999999999),
    isInvalidDecimalNumber,
  ],
  grzField: [containsGreaterThanOrLessThanSign, isInvalidDecimalNumber, isNumberLessThan(0), isNumberGreaterThan(10)],
  gfzField: [containsGreaterThanOrLessThanSign, isInvalidDecimalNumber, isNumberLessThan(0), isNumberGreaterThan(9.99)],
  minRentalTime: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999),
    isInvalidIntegerNumber,
    isLargerThanMaxRentalTimeField,
  ],
  maxRentalTime: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999),
    isInvalidIntegerNumber,
    isSmallerThanMinRentalTimeField,
  ],
  maxNumberOfPersons: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999),
    isInvalidIntegerNumber,
  ],
  frontWindowLength: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(999),
    isInvalidDecimalNumber,
  ],
  numberOfSeats: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999),
    isInvalidIntegerNumber,
  ],
  numberOfBeds: [
    containsGreaterThanOrLessThanSign,
    isNumberLessThan(0),
    isNumberGreaterThan(99999),
    isInvalidIntegerNumber,
  ],
  usageType: [hasNoValue],
  startRentalDateRequired: [hasNoValue, isDateInThePast],
  apiSearchField: [isCharsLengthGreaterThan(15)],
  groupNumber: [isInvalidIntegerNumber, isNumberLessThan(0), isNumberGreaterThan(2147483647)],
  externalId: [isCharsLengthGreaterThan(50), containsGreaterThanOrLessThanSign],
}
export const validationRules: Record<keyof typeof validationRulesRaw, ValidationRule[]> = validationRulesRaw
